import React from 'react';

export const PromoLoader: React.FC = React.memo(() => {
    return <React.Fragment></React.Fragment>;
});
